import { render, staticRenderFns } from "./importTest.vue?vue&type=template&id=42f8a006&scoped=true&"
import script from "./importTest.vue?vue&type=script&lang=js&"
export * from "./importTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f8a006",
  null
  
)

export default component.exports